import { MenuItem } from '../../types/commonTypes';
import { Label } from '../Label';
import clsx from 'clsx';
import { Select } from '../Select/Select';
import { Option } from '../Option';

interface Props {
  disabled?: boolean;
  editing: boolean;
  handleChange?(value: any): void;
  label: string;
  menuItems: MenuItem[];
  name?: string;
  permission: boolean;
  required?: boolean;
  value: number | string | boolean;
  variant?: 'contained' | 'default';
}

export const EditableDropdown = ({
  disabled,
  editing,
  handleChange = () => null,
  label,
  menuItems,
  name,
  permission,
  required = false,
  value,
  variant = 'default',
}: Props) => {
  if (editing && permission) {
    return (
      <Label text={label} required={required}>
        <Select
          disabled={disabled}
          name={name ?? 'Select'}
          onChange={handleChange}
          value={value}
          variant={variant}
        >
          {menuItems.map((o, index) => (
            <Option key={`option-${index + 1}`} value={o.id}>
              {o.name}
            </Option>
          ))}
        </Select>
      </Label>
    );
  }

  return (
    <Label
      classNames={{
        value: clsx({ 'mt-1': variant === 'contained' && !editing }),
      }}
      text={label}
    >
      {menuItems.find((item) => item?.id === value)?.name ?? ''}
    </Label>
  );
};
